/**
 * The file contains all Startup related CRUDS
 */

import { hiveInstance } from "config";
import { getHeader } from "config";

/**
 * To create
 */
export const createEntity = (body) =>
  hiveInstance.post(`/startup`, body, getHeader());

/**
 * To delete
 * @param id --> id of the entity
 */
export const deleteEntity = (id) =>
  hiveInstance.delete(`/startup/${id}`, getHeader());

/**
 * To get all
 */
export const getAllEntity = (query = {}) =>
  hiveInstance.get(
    `/startup${
      Object.keys(query)?.length > 0 ? `?${new URLSearchParams(query)}` : ""
    }`,
    getHeader()
  );

/**
 * Gives
 * @param id --> id
 */
export const getOneEntity = (id) =>
  hiveInstance.get(`/startup/${id}`, getHeader());

/**
 * To update
 * @param id --> id of the entity
 */
export const updateEntity = (id, body) =>
  hiveInstance.patch(`/startup/${id}`, body, getHeader());

/**
 * To get sus flag
 */
export const getSusFlag = (body) =>
  hiveInstance.post(`/check`, body, getHeader());
